import FromDirection from 'components/animations/FromDirection';

const Animated = {FromDirection};

export default Animated;
